/**
 * Untagged product-group pool balance for page headers.
 * Renders: Balance: **pcs** pcs / **nwt** gm
 */
export default function ProductGroupPoolBalance({
  balance,
  className = "ms-auto",
}) {
  if (!balance) return null;

  const pcs = balance.pcs ?? 0;
  const nwt = Number(balance.nwt ?? 0);

  return (
    <span
      className={`text-muted small mb-0 ${className}`.trim()}
      style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}
    >
      Balance:&nbsp;
      <strong>{pcs}</strong> pcs&nbsp;/&nbsp;
      <strong>{nwt.toFixed(3)}</strong> gm
    </span>
  );
}
